"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const React = __importStar(require("react"));
const SvgComponent = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 9, height: 9, fill: "none" }, props),
    React.createElement("path", { fill: "#333", d: "M.472 0 0 .472 8.528 9 9 8.528l-3.31-3.31L8.015 2.89a1.337 1.337 0 0 0 0-1.907c-.267-.266-.61-.4-.953-.4-.344 0-.687.134-.954.4L3.782 3.311.472 0Zm6.59 1.22c.165 0 .322.075.482.236.32.319.32.654 0 .973l-.194.195-.974-.974.195-.194c.16-.16.328-.236.492-.236Zm-1.147.892.973.973-1.67 1.661-.964-.964 1.66-1.67ZM2.86 4.233.953 6.14l-.02.103-.359 1.804-.102.481.481-.102 1.804-.359.103-.02L4.767 6.14l-.462-.461-1.384 1.373a2.235 2.235 0 0 0-.973-.973L3.32 4.695l-.461-.462ZM1.527 6.612c.394.159.702.467.861.86l-1.076.216.215-1.076Z" })));
exports.default = SvgComponent;
//# sourceMappingURL=ReadOnlyIcon.js.map